export const NAME = 'product-datasheet';

export const ALLOWED_EXTENSIONS = '.pdf';
